export const baseUrl = 'https://prodapi.coffeepass.io';
//'https://qaapi.coffeepass.io'; //'https://prodapi.coffeepass.io';
